export const USER_SIGN_IN_REQUEST = 'USER_SIGN_IN_REQUEST';
export const USER_SIGN_IN_SUCCESS = 'USER_SIGN_IN_SUCCESS';
export const USER_SIGN_IN_ERROR = 'USER_SIGN_IN_ERROR';

export const USER_LOG_OUT_REQUEST = 'USER_LOG_OUT_REQUEST';
export const USER_LOG_OUT_SUCCESS = 'USER_LOG_OUT_SUCCESS';
export const USER_LOG_OUT_ERROR = 'USER_LOG_OUT_ERROR';

export const USER_SAVE_URL = 'USER_SAVE_URL';
export const USER_CLEAR_URL = 'USER_CLEAR_URL';

export const MENU_CHANGED = 'MENU_CHANGED';

export const SELECT_MANUFACTURER = 'SELECT_MANUFACTURER';
export const SELECT_INSPECTOR = 'SELECT_INSPECTOR';
export const UPDATE_MANUFACTURER = 'UPDATE_MANUFACTURER';

export const SELECT_YEAR = 'SELECT_YEAR';

export const BOAT_SET_DETAILS_SUCCESS = 'BOAT_SET_DETAILS_SUCCESS';
export const BOAT_SET_DETAILS_ERROR = 'BOAT_SET_DETAILS_ERROR';
export const BOAT_SELECT_TYPE = 'BOAT_SELECT_TYPE';
export const BOAT_SELECT_ENGINE_TYPE = 'BOAT_SELECT_ENGINE_TYPE';
export const BOAT_UPDATE_DETAILS = 'BOAT_UPDATE_DETAILS';
export const BOAT_CLEAR_DETAILS = 'BOAT_CLEAR_DETAILS';



// WEBPACK FOOTER //
// ./src/app/store/actionTypes.js